import { render } from "./MenuHeader.vue?vue&type=template&id=f1aa0106"
import script from "./MenuHeader.vue?vue&type=script&lang=js"
export * from "./MenuHeader.vue?vue&type=script&lang=js"

import "./MenuHeader.vue?vue&type=style&index=0&id=f1aa0106&lang=css"

import exportComponent from "/Users/elvispardo/Desktop/PROYECTOS/pypa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__